import { withQueries } from 'src/utils/reactQuery';
import { Loader } from 'src/components/common/Loader';
import { FilterBlockDiscriminator } from 'src/components/filters/FilterBlockDiscriminator';
import { FilterDescription } from 'src/components/filters/types';
import { UseQueryResult } from 'react-query';

export const Filters = (query: () => UseQueryResult<FilterDescription[]>) =>
  withQueries(
    { filters: query },
    ({ filters }) => {
      return (
        <>
          {filters.map((filter) => (
            <FilterBlockDiscriminator filter={filter} key={filter.queryField} />
          ))}
        </>
      );
    },
    {
      LoaderComponent: Loader,
    },
  );
